export default __webpack_public_path__ + "static/media/urait.7dd82a34.jpg";